import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { LogoutIcon, ProfileTitleIcon, SettingsIcon } from 'config/icons'
import { UserOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Avatar, Badge } from 'antd'
import { profileUrl, settingsUrl } from 'config/menus'
import styles from './style.module.scss'
import { MultiAccount } from "./MultiAccount";

const mapStateToProps = ({ user }) => ({ user })

const ProfileMenu = ({ dispatch, user }) => {
  const [count, setCount] = useState(0)
  const [toggle, setToggle] = useState(false)
  const {platformAccounts} = user
  const hasTwoAccount = platformAccounts.length > 1

  const logout = e => {
    e.preventDefault()
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  const addCount = () => {
    setCount(count)
  }

  const moveToggle = () => {
    setToggle(prev => !prev)
  }

  const menu = (
    <div style={{ width: 220 }}>
      <div className={styles.arrowUp} />
      <Menu
        selectable={false}
        style={{
          borderRadius: 6,
          boxShadow: '0px 6px 12px #00000052',
        }}
      >
        <Menu.Item
          key={'header'}
          style={{
            height: '47px',
            backgroundColor: '#014F86',
            borderRadius: '6px 6px 0px 0px',
            marginTop: '-5px',
          }}
        >
          <strong style={{ color: 'white' }}>{user.name || 'Anonymous'}</strong>
        </Menu.Item>
        <Menu.Item key={'profile'} style={{ height: '45px' }}>
          <a href={profileUrl}>
            <ProfileTitleIcon style={{ color: '#0A9106', fontSize: 16 }} className={'mr-2'} />
            <span className={styles.menuOption}>
              <FormattedMessage id="global.profile" />
            </span>
          </a>
        </Menu.Item>

        {!user.onlyCandidates && user.role.includes("ROLE_ADMIN") && (
          <Menu.Item key={'settings'} style={{ height: '45px' }}>
            <a href={settingsUrl}>
              <SettingsIcon style={{ color: '#9129BC', fontSize: 16 }} className={'mr-2'} />
              <span className={styles.menuOption}>
                <FormattedMessage id="annunci.settings" />
              </span>
            </a>
          </Menu.Item>
        )}

        {!user.onlyCandidates && (
          <div>
            {hasTwoAccount && <div style={{border: '1px solid #f5f5f5'}} />}
            <MultiAccount
              platformAccounts={platformAccounts}
              hasTwoAccount={hasTwoAccount}
              user={user}
            />
            {hasTwoAccount && <div style={{border: '1px solid #f5f5f5'}} />}
          </div>
        )}

        <Menu.Item key={'exit'} style={{height: '45px'}}>
          <a href="#" onClick={logout}>
            <LogoutIcon style={{color: '#DB5F00', fontSize: 16}} className={'mr-2'} />
            <span className={styles.menuOption}>
              <FormattedMessage id="global.exit" />
            </span>
          </a>
        </Menu.Item>
      </Menu>
    </div>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']} onVisibleChange={addCount} onClick={moveToggle}>
      <div style={{ display: 'flex' }}>
        <Badge count={count}>
          <Avatar src={user.imageUrl} className={styles.avatar} shape="circle" size="large" icon={<UserOutlined />} />
        </Badge>
        <div className={toggle ? styles.dropdownUp : styles.dropdownDown} />
      </div>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
